export default {
      id: "icon-social-facebook-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.svg#icon-social-facebook",
      toString: function () {
        return this.url;
      }
    }